// BrandHeader.js

import React from 'react';

const BrandHeader = (props) => {
  return (
    <header>
      {/* <h1>{props.brandInformation?.headerName}</h1> */}
        <img className="header-image my-3" src={props.brandInformation?.logoPath} alt={props.brandInformation?.headerName} />
    </header>
  );
};

export default BrandHeader;
